import { ReactNode } from "react";

import Box from "ds/components/Box";

type FieldsGroupProps = {
  children: ReactNode;
};

const FieldsGroup = ({ children }: FieldsGroupProps) => (
  <Box direction="column" gap="large" fullWidth>
    {children}
  </Box>
);

export default FieldsGroup;
